import { getFontWeightStyle } from 'src/components/10-atoms/typography/utils';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import { MathFieldRenderer } from './formats/MathField';
export default function useStyles(containerId, { typographyFontWeight, typographyVariant = TypographyVariant.READER, }) {
    const [{ theme }] = useTheme();
    const typographyVariantStyle = theme.typography[typographyVariant].style;
    const typographyFontWeightStyle = getFontWeightStyle(typographyFontWeight);
    return `
    #${containerId} .ql-editor {
      overflow-y: visible;
      height: auto;
      /* background-color: ${theme.palette.background.main}; */
      color: ${theme.palette.typography.primary};
      padding: 0;
      padding-bottom: 0;

      /* Typography styles */
      font-family: ${typographyFontWeightStyle.fontFamily ?? "'Montserrat', sans-serif"};
      
      ${typographyFontWeightStyle.fontWeight
        ? `font-weight: ${typographyFontWeightStyle.fontWeight};`
        : `font-weight: 500;`}

      ${typographyVariantStyle.fontSize
        ? `font-size: ${typographyVariantStyle.fontSize};`
        : ''}
      
      ${typographyVariantStyle.lineHeight
        ? `line-height: ${typographyVariantStyle.lineHeight};`
        : ''}
      
      ${typographyVariantStyle.wordSpacing
        ? `word-spacing: ${typographyVariantStyle.wordSpacing}px;`
        : ''}
      
      ${typographyVariantStyle.letterSpacing
        ? `letter-spacing: ${typographyVariantStyle.letterSpacing}px;`
        : ''}
    }
      
    .ql-editor.ql-blank::before {
      color: ${theme.palette.typography.placeholder} !important;
    }
      
    .ql-editor[contenteditable="true"] {
      padding: ${theme.spacing.standard.xs}px ${theme.spacing.page}px !important;
    }

    @keyframes loader-rotate {
      0% {
        transform: rotateZ(0deg);
      }
      100% {
        transform: rotateZ(360deg);
      }
    }

    .ql-editor .image-loader-container {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${theme.palette.backdrop.main};
      border-radius: ${theme.borderRadius.standard.md}px;
    }
    
    .ql-editor .image-loader-container .image-loader, .ql-editor .img2Txt-loader .loader-container .progress-loader {
      width: ${theme.borderRadius.standard.xxxl}px;
      height: ${theme.borderRadius.standard.xxxl}px;
      border-radius: ${theme.borderRadius.standard.xxxl}px;
      border: 4px solid ${theme.palette.background.darker};
      border-top: 4px solid ${theme.palette.primary.dark};
      animation: loader-rotate 1s linear infinite;
    }

    .ql-editor a {
      color: ${theme.palette.typography.link}
    }

    .ql-editor span:has(> div.${MathFieldRenderer.className}), s:has(> div.${MathFieldRenderer.className}) {
      display: inline-block;
    }

    /* Quill-Better-Table related styles*/

    .quill-better-table, .quill-better-table th, .quill-better-table td {
      border: 1px solid ${theme.palette.typography.primary} !important;
    }

    .qlbt-operation-menu {
      width: 240px !important;

      font-family: 'Montserrat', sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
    }

    .qlbt-operation-menu .qlbt-operation-menu-item {
      background-color: ${theme.palette.background.dark};
      color: ${theme.palette.typography.primary};
    }

    .qlbt-operation-menu .qlbt-operation-menu-icon path {
      fill: ${theme.palette.typography.primary};
    }
      
    .qlbt-operation-menu .qlbt-operation-menu-dividing {
      background-color: ${theme.palette.background.darker};
    }

    .ql-editor .${MathFieldRenderer.className} {
      overflow-x: auto;
      overflow-y: hidden;
      height: max-content;
    }

    .ql-editor .${MathFieldRenderer.className} ML__strut--bottom {
      vertical-align: 0 !important;
    }

    /* Img2TxtLoader related styles */
    .ql-editor .img2Txt-loader {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.standard.xs}px;
      position: relative;
      border-radius: ${theme.borderRadius.standard.md}px;
      overflow: hidden;
    }

    .ql-editor .img2Txt-loader .loader-container {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: ${theme.spacing.standard.md}px;
      background-color: ${theme.palette.backdrop.darker};
      border-radius: ${theme.borderRadius.standard.md}px;
    }

    .ql-editor .img2Txt-loader .loader-container .caption {
      font-size: 18px;
      color: ${theme.palette.typography.backdrop};
      font-weight: 500;
    }

    .ql-editor h1, .ql-editor h2, .ql-editor h3, .ql-editor h4, .ql-editor h5, .ql-editor h6 {
      margin-bottom: ${theme.spacing.standard.sm}px;
      margin-top: ${theme.spacing.standard.lg}px;
    }

    .ql-editor h1 {
      line-height: 1.3;
    }

    .ql-editor h2 {
      line-height: 1.4;
    }

    .ql-editor h3 {
      line-height: 1.5;
    }

    .ql-editor h4 {
      line-height: 1.6;
    }

    .ql-editor h5 {
      line-height: 1.7;
    }

    .ql-editor h6 {
      line-height: 1.8;
    }
  `;
}
